/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import getAssociatedBoards from '../../services/get-associated-boards/index.tsx';
import getAssociatedSubscriptions from '../../services/get-associated-subscriptions/index.tsx';
import {
	type Action,
	type AssociatedItemsRetrievedAction,
	GET_ASSOCIATED_ITEMS,
	type GetAssociatedItemsFailedAction,
	associatedItemsRetrieved,
	getAssociatedItemsFailed,
} from '../../state/actions.tsx';
import { getFilter, getOnInitialised, getOnFilterInitiateFailed } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const getItems = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
): Observable<AssociatedItemsRetrievedAction | GetAssociatedItemsFailedAction> =>
	action$.ofType(GET_ASSOCIATED_ITEMS).mergeMap(() => {
		const state = store.getState();
		const filter = getFilter(state);

		return Observable.forkJoin(
			Observable.fromPromise(getAssociatedBoards(filter.id)),
			Observable.fromPromise(getAssociatedSubscriptions(filter.id)),
		) // oxlint-disable-next-line @typescript-eslint/no-explicit-any
			.map(([boards, subscriptions]: [any, any]) => {
				const { users, groups } = subscriptions;
				getOnInitialised(state)();
				return associatedItemsRetrieved({ boards, users, groups });
			})
			.catch((error: FetchError) => {
				log.safeErrorWithoutCustomerData(
					'directories.filters-v2.delete-modal.ops.get-associated-items',
					error.message,
					error,
				);
				getOnFilterInitiateFailed(state)(filter);
				return Observable.of(getAssociatedItemsFailed());
			});
	});

export default getItems;
